import React from 'react'
import { useTranslation } from 'react-i18next'
import BaseAISummaryWidget from './common/BaseAISummaryWidget'
import DazzedParagraph14 from 'components/common/text/DazzedParagraph14'
import { trackEvent } from 'utils/analyticsUtils'
import useSelectPatientView from '../../useSelectPatientView'
import { PatientSidebarItemKeys } from '../../PatientSidebar/patientSidebarConsts'
import NoteAISummary from '../CopilotSettings/icons/Insights/NoteAISummary'

const NotesSummaryWidget = ({ isLoading, notesSummary = '', updatedAt }) => {
  const { t } = useTranslation()

  const { selectPatientView } = useSelectPatientView()

  const handleButtonClick = () => {
    trackEvent('Patient Copilot - Notes AI Summary - Go to notes clicked')
    selectPatientView(PatientSidebarItemKeys.Notes)
  }

  return (
    <BaseAISummaryWidget
      title={t('pages.patients.patientSidebar.items.copilot.copilotInsights.notesSummary.title')}
      titleIcon={<NoteAISummary />}
      isLoading={isLoading}
      buttonLabel={t('pages.patients.patientSidebar.items.copilot.copilotInsights.notesSummary.button')}
      onButtonClick={handleButtonClick}
      updatedAt={updatedAt}
    >
      {notesSummary ? (
        <DazzedParagraph14>{notesSummary}</DazzedParagraph14>
      ) : (
        <DazzedParagraph14 color="var(--text-color-18)" strong>
          {t('pages.patients.patientSidebar.items.copilot.copilotInsights.noDataAvailable')}
        </DazzedParagraph14>
      )}
    </BaseAISummaryWidget>
  )
}

export default NotesSummaryWidget
